'use strict';

module.exports = function (colName, ev) {

  if (!this.sortable(colName)) return;

  if (ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
    this.setUserMultiSort(colName);
  } else {
    this.userMultiSorting = {};
    this.orderBy.column = colName;
    this.orderBy.ascending = colName == this.orderBy.column ? !this.orderBy.ascending : true;

    this.updateState('orderBy', this.orderBy);
    this.dispatch('sorted', JSON.parse(JSON.stringify(this.orderBy)));
  }

  if (this.source == 'server') {
    this.getData();
  }
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/order-by-column.js